import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Arrow = /*#__PURE__*/function (_Component) {
  _inherits(Arrow, _Component);
  var _super = _createSuper(Arrow);
  function Arrow() {
    _classCallCheck(this, Arrow);
    return _super.apply(this, arguments);
  }
  _createClass(Arrow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        active = _this$props.active,
        direction = _this$props.direction,
        className = _this$props.className,
        onClick = _this$props.onClick;
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": "".concat(direction === 'left' ? 'Предыдущий' : 'Следующий', " \u0441\u043B\u0430\u0439\u0434"),
        className: cx('arrowButton', direction, {
          arrowDisabled: !active
        }, className),
        onClick: active ? onClick : function () {}
      }, /*#__PURE__*/React.createElement("span", {
        className: cx('arrow', direction)
      }));
    }
  }]);
  return Arrow;
}(Component);
_defineProperty(Arrow, "defaultProps", {
  active: false,
  onClick: function onClick() {
    return undefined;
  },
  className: null
});
Arrow.propTypes = process.env.NODE_ENV !== "production" ? {
  active: PropTypes.bool,
  direction: PropTypes.oneOf(['left', 'right']).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.any
} : {};